module.exports = __webpack_public_path__ + "media/site_templates/www.fencingcontractors.net.au/images/our_services_3-c9ac9c43d8d1523b90eadfac8d8ddcbe.jpg";